import { calculateRiskOfHypertension, yesNoDontKnow } from "./helpers";
import { Steps } from "./types";

export const hypertensionSteps: Steps = {
  q1: {
    id: "q1",
    backendQuestionId: 177,
    slug: "hypertonidiagnos",
    text: "Hur kan vi hjälpa dig?",
    type: "multipleChoice",
    allowDirectAccess: true,
    fullWidthOptions: true,
    options: [
      {
        text: "Behandla mitt höga blodtryck",
        value: 1,
        clarification:
          "För dig som fått diagnosen högt blodtryck efter utredning och blivit rekommenderad behandling.",
      },
      {
        text: "Kolla om jag har högt blodtryck",
        value: 0,
        clarification:
          "För dig som är osäker och vill kolla om du har högt blodtryck eller inte.",
      },
    ],
    nextStep: (answers) => (answers?.q1 === 1 ? "q18" : "q2"),
  },
  q2: {
    id: "q2",
    slug: "över-35",
    text: "Hur gammal är du?",
    type: "multipleChoice",
    options: [
      { text: "Yngre än 35 år", value: 0 },
      { text: "Mellan 35 och 49 år", value: 1 },
      { text: "50 år eller äldre", value: 2 },
    ],
    disclaimer:
      "Frågorna är ett självtest som hjälper dig att förstå din risk för högt blodtryck och uppmuntrar till förebyggande åtgärder. För diagnos krävs läkarbedömning.",
    flowProgress: 1 / 8,
    nextStep: (answers) => (answers?.q2 ? "q3" : "d1"),
  },
  q3: {
    id: "q3",
    slug: "mätt-högt",
    text: "Har du vid något tillfälle uppmätt ett högt blodtryck i samband med en undersökning?",
    clarification:
      "T.ex. en hälsoundersökning, vårdbesök, blodcentralen eller på apotek. Ett blodtrycksvärde på 140/90 eller högre räknas som ett högt blodtryck.",
    type: "boolean",
    flowProgress: 2 / 8,
    nextStep: () => "q4",
  },
  q4: {
    id: "q4",
    slug: "diagnoser-1",
    text: "Har, eller har du haft någon av följande diagnoser?",
    clarification: [
      "Förmaksflimmer eller förmaksfladder",
      "Infektion i hjärtklaff, hjärtmuskel eller hjärtsäck",
      "Förträngning eller läckage i hjärtklaff",
      "Venös blodpropp i ben eller arm",
      "Blodpropp i lungkärlen",
      "Annan hjärt-kärlsjukdom",
    ],
    type: "boolean",
    flowProgress: 3 / 8,
    nextStep: () => "q32",
  },
  q6: {
    id: "q6",
    slug: "kroppsmått-hypertoni",
    text: "Ange din längd och vikt",
    clarification: "Ange ner till en decimal.",
    type: "physicalStats",
    flowProgress: 6 / 8,
    nextStep: () => "q13",
  },
  q18: {
    id: "q18",
    slug: "motivation-hypertoni",
    text: "Du är i goda händer!",
    type: "motivationAlreadyInTreatment",
    flowProgress: 1,
    nextStep: () => null,
  },
  q33: {
    id: "q33",
    slug: "motivation-hypertoni-ny",
    text: "Du är i goda händer!",
    type: "motivationNewPatient",
    flowProgress: 1,
    nextStep: () => null,
  },
  q10: {
    id: "q10",
    slug: "hjärtsvikt-njursvikt",
    text: "Stämmer något av följande in på dig? TODO: denna ska nog bort",
    clarification: [
      "Jag har hjärtsvikt eller njursvikt",
      "Jag är gravid, ammar eller planerar att bli gravid inom 3 månader",
    ],
    type: "boolean",
    nextStep: () => null,
  },
  q12: {
    id: "q12",
    slug: "diabetes",
    text: "Har du diabetes?",
    clarification: "OBS! Ej inräknat graviditetsdiabetes.",
    type: "multipleChoice",
    options: [
      { text: "Ja", value: 1 },
      { text: "Nej", value: 0 },
    ],
    flowProgress: 5 / 8,
    nextStep: () => "q6",
  },
  q13: {
    id: "q13",
    slug: "ärftlighet",
    text: "Har du någon förälder eller syskon som behandlats för högt blodtryck innan 65 års ålder?",
    clarification: "OBS! Ej inräknat graviditetsdiabetes.",
    type: "multipleChoice",
    options: yesNoDontKnow,
    flowProgress: 7 / 8,
    nextStep: (answers) => {
      const risk = calculateRiskOfHypertension(answers);

      return risk === "low" ? "d4" : "q33";
    },
  },
  q32: {
    id: "q32",
    slug: "diagnoser-2",
    text: "Har, eller har du haft någon av följande diagnoser?",
    clarification: [
      "Förträngning i hjärtats kranskärl",
      "Hjärtinfrakt",
      "Stroke, TIA eller slaganfall",
      "Hjärnblödning (ej orsakad av huvudskada)",
      "Pulsåderbråck eller brusten pulsåder",
      "Förträngning i benens blodkärl (fönstertittarsjuka)",
    ],
    type: "boolean",
    flowProgress: 4 / 8,
    nextStep: () => "q12",
  },
};
